// extracted by mini-css-extract-plugin
export var root = "Logo-module--root--ms+Li";